import * as React from "react";
import Component from "../../../../AbstractComponent";

export class Title extends Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { title } = this.props;
    return (
        <div 
            style={{textAlign: "center", marginBottom: "10px", fontSize: "16px", fontWeight: "bold", ...this.props?.style}}
            className={this.props?.className}
        >
            {title}
        </div>
    );
  }
}
